import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { useSnackbar } from '@/helpers/hooks/useSnackbar'
import { downloadHref } from '@/utils'

export interface ExportTwilioChatCSVRequest {
  chatId: number
}

export interface DownloadTwilioChatCSVRequest extends ExportTwilioChatCSVRequest {
  fileName: string
}

export const exportTwilioChatCSV = async (data: ExportTwilioChatCSVRequest) => {
  const response = await authAPI.get<Blob>('/twilio-chat/export-csv', {
    params: data,
    responseType: 'blob',
  })
  return response.data
}

export const useExportTwilioChatCSV = () => {
  const { displaySnackbar } = useSnackbar()

  return useMutation({
    mutationFn: async ({ fileName, ...rest }: DownloadTwilioChatCSVRequest) => {
      const blob = await exportTwilioChatCSV(rest)
      const objectUrl = URL.createObjectURL(blob)
      downloadHref(objectUrl, fileName)
      URL.revokeObjectURL(objectUrl)
    },
    onError: (error) => {
      displaySnackbar(error.message, true)
    },
  })
}
